<template>
  <div>
    <textarea :id="Id" />
  </div>
</template>
<script>
  import '../../../static/zh_CN.js';

  export default {
    data() {
      let random = (Math.random() + '').split('.')[1];
      const Id = Date.now() + random * 1;
      return {
        Id,
        Editor: null,
        editorVM: null,
        status: 'INIT',
        DefaultConfig: {
          // GLOBAL
          maxLength: 10000,
          remove_trailing_brs: false,
          // entity_encoding: 'raw',
          height: 500,
          theme: 'modern',
          menubar: 'file edit insert view format table',
          menu: {
            file: { title: 'File', items: 'newdocument' },
            edit: { title: 'Edit', items: 'undo redo | cut copy paste pastetext | selectall' },
            insert: { title: 'Insert', items: 'link media | template hr' },
            view: { title: 'View', items: 'visualaid | preview' },
            format: { title: 'Format', items: 'bold italic underline strikethrough superscript subscript | formats | removeformat' },
            table: { title: 'Table', items: 'inserttable tableprops deletetable | cell row column' },
          },
          toolbar: [`
          styleselect |
          fontselect |
          visualaid |
          formatselect |
          fontsizeselect |`,
                    `forecolor backcolor |
          bold italic underline strikethrough |
          image  media |
          table |
          alignleft aligncenter alignright alignjustify`, `
          outdent indent |
          numlist bullist |
          preview removeformat  hr |
          paste code  link |
          undo redo |
          pagebreak |
          wordcount |
          fullscreen `],
          plugins: `
            paste
            importcss
            image
            code
            pagebreak
            table
            advlist
            fullscreen
            wordcount
            link
            media
            lists
            textcolor
            colorpicker
            hr
            preview
          `,
          link_context_toolbar: true,
          content_css: "/static/editor.css",
          textcolor_map: [
            "595959", "常规1",
            "f79646", "常规2",
            "000000", "Black",
            "993300", "Burnt orange",
            "333300", "Dark olive",
            "003300", "Dark green",
            "003366", "Dark azure",
            "000080", "Navy Blue",
            "333399", "Indigo",
            "333333", "Very dark gray",
            "800000", "Maroon",
            "FF6600", "Orange",
            "808000", "Olive",
            "008000", "Green",
            "008080", "Teal",
            "0000FF", "Blue",
            "666699", "Grayish blue",
            "808080", "Gray",
            "FF0000", "Red",
            "FF9900", "Amber",
            "99CC00", "Yellow green",
            "339966", "Sea green",
            "33CCCC", "Turquoise",
            "3366FF", "Royal blue",
            "800080", "Purple",
            "999999", "Medium gray",
            "FF00FF", "Magenta",
            "FFCC00", "Gold",
            "FFFF00", "Yellow",
            "00FF00", "Lime",
            "00FFFF", "Aqua",
            "00CCFF", "Sky blue",
            "993366", "Red violet",
            "FFFFFF", "White",
            "FF99CC", "Pink",
            "FFCC99", "Peach",
            "FFFF99", "Light yellow",
            "CCFFCC", "Pale green",
            "CCFFFF", "Pale cyan",
            "99CCFF", "Light sky blue",
            "CC99FF", "Plum"],
          // CONFIG

          forced_root_block: 'p',
          force_p_newlines: true,
          importcss_append: true,

          // CONFIG: ContentStyle 这块很重要， 在最后呈现的页面也要写入这个基本样式保证前后一致， `table`和`img`的问题基本就靠这个来填坑了
          content_style: `
            *                         { padding:0; margin:0; }
            html, body                { height:100%; }
            img                       { max-width:100%; display:block;height:auto; }
            a                         { text-decoration: none; }
            iframe                    { width: 100%; }
            p                         { margin: 0px; }
            table                     { word-wrap:break-word; word-break:break-all; max-width:100%; border:none; border-color:#999; }
            .mce-object-iframe        { width:100%; box-sizing:border-box; margin:0; padding:0; }
            ul,ol                     { list-style-position:inside; }
          `,

          insert_button_items: 'image link | inserttable',

          // CONFIG: Paste
          paste_retain_style_properties: 'all',
          paste_word_valid_elements: '*[*]', // word需要它
          paste_data_images: true, // 粘贴的同时能把内容里的图片自动上传，非常强力的功能
          paste_convert_word_fake_lists: false, // 插入word文档需要该属性
          paste_webkit_styles: 'all',
          paste_merge_formats: true,
          nonbreaking_force_tab: false,
          paste_auto_cleanup_on_paste: false,
          // CONFIG: Font
          fontsize_formats: '10px 11px 12px 14px 16px 18px 20px 24px',

          // CONFIG: StyleSelect
          style_formats: [
            {
              title: '首行缩进',
              block: 'p',
              styles: { 'text-indent': '2em' }
            },
            {
              title: '行高',
              items: [
                { title: '1', styles: { 'line-height': '1' }, inline: 'span' },
                { title: '1.5', styles: { 'line-height': '1.5' }, inline: 'span' },
                { title: '2', styles: { 'line-height': '2' }, inline: 'span' },
                { title: '2.5', styles: { 'line-height': '2.5' }, inline: 'span' },
                { title: '3', styles: { 'line-height': '3' }, inline: 'span' }
              ]
            }, {
              title: '段落间距-上',
              items: [
                { title: '5', styles: { 'margin-top': '5px' }, block: 'p' },
                { title: '10', styles: { 'margin-top': '10px' }, block: 'p' },
                { title: '15', styles: { 'margin-top': '15px' }, block: 'p' },
                { title: '20', styles: { 'margin-top': '20px' }, block: 'p' },
                { title: '25', styles: { 'margin-top': '25px' }, block: 'p' }
              ]
            }, {
              title: '段落间距-下',
              items: [
                { title: '5', styles: { 'margin-bottom': '5px' }, block: 'p' },
                { title: '10', styles: { 'margin-bottom': '10px' }, block: 'p' },
                { title: '15', styles: { 'margin-bottom': '15px' }, block: 'p' },
                { title: '20', styles: { 'margin-bottom': '20px' }, block: 'p' },
                { title: '25', styles: { 'margin-bottom': '25px' }, block: 'p' }
              ]
            }
          ],

          // FontSelect
          font_formats: `
            微软雅黑=微软雅黑;
            宋体=宋体;
            黑体=黑体;
            仿宋=仿宋;
            楷体=楷体;
            隶书=隶书;
            幼圆=幼圆;
            Andale Mono=andale mono,times;
            Arial=arial, helvetica,
            sans-serif;
            Arial Black=arial black, avant garde;
            Book Antiqua=book antiqua,palatino;
            Comic Sans MS=comic sans ms,sans-serif;
            Courier New=courier new,courier;
            Georgia=georgia,palatino;
            Helvetica=helvetica;
            Impact=impact,chicago;
            Symbol=symbol;
            Tahoma=tahoma,arial,helvetica,sans-serif;
            Terminal=terminal,monaco;
            Times New Roman=times new roman,times;
            Trebuchet MS=trebuchet ms,geneva;
            Verdana=verdana,geneva;
            Webdings=webdings;
            Wingdings=wingdings,zapf dingbats`,

          // Tab
          tabfocus_elements: ':prev,:next',
          object_resizing: true,

          // Image
          imagetools_toolbar: 'rotateleft rotateright | flipv fliph | editimage imageoptions'
        }
      };
    },
    props: {
      disabled: {
        default: false,
        type: Boolean
      },
      value: {
        default: '',
        type: String
      },
      maxLength: {
        default: 50000,
        type: Number
      },
      config: {
        type: Object,
        default: () => {
          return {
            theme: 'modern',
            height: 300
          };
        }
      },
      // hasWatermark   1打水印 0 不打
      hasWatermark: {
        type: String,
        default: '0'
      },
      url: {
        default: '/upload/uploadRichTextImage.htm',
        type: String
      },
      accept: {
        default: 'image/jpeg, image/png, image/gif',
        type: String
      },
      maxSize: {
        default: 5242880,
        type: Number
      },
      withCredentials: {
        default: false,
        type: Boolean
      }
    },
    watch: {
      value(val) {
        if (this.status === 'CHANGED' && !val) {
          // 如果外部的值为空了，则
          this.editorVM && this.editorVM.setContent(val);
        }
        console.log(this.status, /status/);
        if (this.status === 'CHANGED') return;
        if (!this.editorVM || !this.editorVM.initialized) return;
        // this.editorVM.setContent(encodeURI(val))
        console.log(this.status, /2222/);
        this.editorVM.setContent(val);
      }
    },
    mounted() {
      this.$nextTick(() => {
        this.init();
      });
    },
    beforeDestroy() {
      // 销毁tinymce
      this.$emit('on-destroy');
      this.editorVM.remove();
      this.editorVM.destroy();
      // window.tinymce.remove(`#${this.Id}`);
      let arr = document.getElementsByClassName('mce-notification-error');
      if (arr) {
        let myArr = Array.prototype.slice.call(arr);
        myArr.forEach(item => {
          document.body.removeChild(item);
        });
      }

    },
    methods: {
      init() {
        const self = this;

        this.Editor = window.tinymce.init({
          // 默认配置
          ...this.DefaultConfig,
          readonly: this.disabled ? 1 : '',
          maxLength: this.maxLength,
          image_dimensions: false,
          force_p_newlines: false,
          // forced_root_block: false,
          // 图片上传
          images_upload_handler(blobInfo, success, failure) {
            // if (blobInfo.blob().size > self.maxSize) {
            //   // failure('文件体积不可大于5M');
            //   self.$message.error('文件体积不可大于5M')
            //   return;
            // }

            // if (self.accept.indexOf(blobInfo.blob().type) >= 0) {
            if (self.accept.indexOf('image') >= 0) {
              let formData = new FormData();
              formData.append('token', localStorage.getItem('userToken'));
              formData.append('upFile', blobInfo.blob());
              formData.append('hasWatermark', self.hasWatermark);
              self.$axios({
                url: self.url,
                method: 'POST',
                headers: {
                  'Content-Type': 'multipart/form-data'
                },
                data: formData,
                catchErrBySelf: true
              }).then(res => {
                success(res.data);
                self.$emit('on-upload-complete', res);
              }).catch(err => {
                failure(err.errorMsg);
                self.$emit('on-upload-fail');
              });
            } else {
              failure('图片上传错误');
            }
          },

          // prop内传入的的config
          ...this.config,

          // 挂载的DOM对象
          selector: `#${this.Id}`,
          setup: (editor) => {
            // 抛出 'on-ready' 事件钩子
            this.editorVM = editor;
            window.editorVM = editor;
            editor.on(
              'init', () => {
                self.loading = false;
                self.$emit('on-ready');
                // self.value && editor.setContent(encodeURI(self.value))
                self.value && editor.setContent(self.value);
              }
            );
            // 抛出 'input' 事件钩子，同步value数据
            editor.on(
              'input change undo redo execCommand KeyUp', () => {
                if (this.status === 'INPUT' || this.status === 'INIT') {
                  this.status = 'CHANGED';
                }
                self.$emit('input', editor.getContent());
              }
            );
            editor.on('NodeChange', () => {
              this.$emit('input', editor.getContent());
            });
          }
        });
      }
    }
  };
</script>


// WEBPACK FOOTER //
// src/components/editor/index.vue